import Svg, { Props as SvgProps } from '../svg/Svg';
import { KeyboardEvent, MouseEvent } from 'react';
interface ButtonModel {
  disabled?: boolean;
  icon?: SvgProps;
  link?: boolean;
  mainClass?: string;
  styleModifier?: (
    | 'fm-a-button--yellow'
    | 'fm-a-button--dark'
    | 'fm-a-button--blue'
    | 'fm-a-button--light-outline'
    | 'fm-a-button--small-x-padding'
    | 'fm-a-button--small-y-padding'
    | 'fm-a-button--small'
    | 'fm-a-button--icon-right'
    | 'fm-a-button--text-white'
    | 'fm-a-button--xs'
    | 'fm-a-button--border-yellow'
  )[];
  url?: string;
  newTab?: boolean;
  raw?: boolean;
  text: string;
  textMobile?: string;
  onClick?: (event: MouseEvent) => any;
  type?: 'button' | 'submit' | 'reset';
  role?: string;
  tabIndex?: number;
  onKeyDown?: (event: KeyboardEvent) => any;
  refButton?: (ref: any) => any;
  commandType?: commandTypeButton;
  dataHref?: string;
}

export enum commandTypeButton {
  order = 'order',
  bookCollection = 'book-collection',
  openDropdown = 'open-dropdown',
}

const ButtonInner = ({ text, textMobile }: ButtonModel) => {
  return (
    <div className="fm-body-bold">
      {!textMobile ? (
        text
      ) : (
        <>
          <span className="text-desktop">{text}</span> <span className="text-mobile">{textMobile}</span>
        </>
      )}
    </div>
  );
};

const Button = ({
  disabled,
  icon,
  link,
  role,
  tabIndex,
  refButton,
  onKeyDown,
  mainClass,
  styleModifier,
  url,
  text,
  onClick,
  textMobile,
  ...props
}: ButtonModel) => {
  const inner = <ButtonInner mainClass={mainClass} text={text} textMobile={textMobile} />;
  const className = mainClass + ' fm-a-button tfm ' + (styleModifier ? styleModifier.join(' ') : '');

  return link ? (
    <a className={className} href={url} onClick={onClick} role={role} tabIndex={tabIndex || 0} onKeyDown={onKeyDown} ref={refButton}>
      {icon && <Svg {...icon} />}
      {inner}
    </a>
  ) : (
    <button
      className={className}
      disabled={disabled}
      onClick={onClick}
      type={props.type}
      ref={refButton}
      role={role}
      tabIndex={tabIndex || 0}
      onKeyDown={onKeyDown}
      data-href={props.dataHref}
    >
      {icon && <Svg {...icon} />}
      {inner}
    </button>
  );
};

export default Button;
export type { ButtonModel };
